export interface ReferrerParams {
    link: string;
}

export function reffererFilter(params: ReferrerParams) {
    this.params = params;
    if (document.referrer.includes(this.params.link)) {
        return true;
    } else {
        return false;
    }
}
